import { BodyAuthComponents } from "../components/BodyAuth";
import logoWithoutName from "../../../image/logoWithoutName.svg";
import { FormEvent, useState } from "react";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import { postLogin } from "../../../page/auth/service/service";
import { isEmailValid } from "../../../libs/validation-email";
import useAuthData from "../../../hook/useAppData";
import { Link, useHistory } from "react-router-dom";
import { isPasswordValid } from "../../../libs/validationPassaword";
import { InputV3 } from "../../../components/InputV3";
import { IconEye, IconEyeOutline } from "../../../icons";
import { toastError } from "../../../components/Toast";
import { Toaster } from "react-hot-toast";
import { PatchNotesComponent } from "../PatchNotes/PatchNotesComponent";

export const SignIn = () => {
  const { setToken, setLoginData } = useAuthData();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [errorEmail, setErrorEmail] = useState<{ status: boolean; message: string }>({ status: false, message: "Login Inválido" });
  const [errorPassword, setErrorPassword] = useState<{ status: boolean; message: string }>({ status: false, message: "Login Inválido" });
  const [hiddenPassword, setHiddenPassword] = useState(true);
  const historyRouter = useHistory();

  const handleSubmitLogin = async (event: FormEvent) => {
    event.preventDefault();
    if (await verefyValuesOfLogin()) return;
    const loginValues = {
      email: values.email,
      password: values.password,
    };
    const resLogin = await postLogin(loginValues);
    if (resLogin?.ok) return successLogin(resLogin, loginValues);
    return toastError("Não foi possível realizar o login");
  };

  const verefyValuesOfLogin = async (): Promise<boolean> => {
    const emailValid = isEmailValid(values.email);
    if (!emailValid) {
      setErrorEmail({ status: true, message: "Email inválido" });
      return true;
    } else setErrorEmail({ status: false, message: "" });

    const isDevelopmentServer =
      window.location.href.includes("dev") || window.location.href.includes("hml") || window.location.href.includes("localhost");
    if (values?.password === "admin" && isDevelopmentServer) return false;
    const passwordValid = isPasswordValid(values.password).validationPassword();
    if (!passwordValid.isValid) {
      setErrorPassword({ status: true, message: passwordValid.message });
      return true;
    }

    return false;
  };

  const successLogin = async (resLogin: Response, loginValues) => {
    const resLoginJson = await resLogin.json();
    setToken(`Bearer ${resLoginJson.token}`);
    setLoginData(loginValues);
    return historyRouter.push("/");
  };

  return (
    <>
      <Toaster />
      <BodyAuthComponents className="flex flex-col items-center justify-center gap-12">
        <div className="flex flex-col items-center ">
          <img src={logoWithoutName} className="w-40" />
          <h1 className="text-5xl font-semibold">Seja bem vindo</h1>
          <p className="text-1.6rem mt-5 text-textPrimary">Faça o login no Integra Admin</p>
        </div>
        <form onSubmit={handleSubmitLogin} className="w-full flex flex-col items-center gap-12">
          <div className="flex flex-col items-center w-3/5 sm:w-4/5 gap-4">
            <Input
              className=""
              type="email"
              label="Login"
              placeholder="Digite seu e-mail aqui"
              name="email"
              required={true}
              value={values.email}
              setValue={(e) =>
                setValues({
                  ...values,
                  email: e.target.value,
                })
              }
              errorMessage={errorEmail.message}
              errorStatus={errorEmail.status}
              autofocus={true}
              asterisk={false}
            />
            <InputV3
              inputProps={{
                placeholder: "Digite sua senha aqui",
                value: values?.password,
                onChange: (e) => setValues({ ...values, password: e.target.value }),
                type: hiddenPassword ? "password" : "text",
              }}
              labelProps={{
                children: "Senha",
              }}
              iconButtonProps={{ icon: hiddenPassword ? IconEyeOutline : IconEye, onClick: () => setHiddenPassword((oldValue) => !oldValue) }}
              errorMessage={errorPassword.message}
              errorStatus={errorPassword.status}
            />
          </div>
          <div className="flex flex-col w-3/5 sm:w-4/5 gap-6 px-4">
            <Button type="submit" className="bg-primary w-full rounded-xl">
              Entrar
            </Button>
            <Link to="/signup" className="w-full h-full">
              <Button className="bg-blue-100 text-primary w-full rounded-xl">Criar Conta</Button>
            </Link>
            <Link to="/recover-password" className="w-full h-full">
              <Button className="w-full text-primary hover:bg-blue-100 rounded-xl">Esqueci/Redefinir minha senha</Button>
            </Link>
          </div>
          <PatchNotesComponent />
        </form>
      </BodyAuthComponents>
    </>
  );
};
